import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { Context, useContext, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { useData } from "../../hooks";
import SetBacksInspectionForm from "../Components/SetBacksInspectionForm";
import { SetBacksInspectionInput } from "../Components/SetBacksInspectionForm.types";

// TODO: Add error handling



const EditSetBacksPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
 const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
 const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    const path = usePath();
    const editData = useData<SetBacksInspectionInput>(path.current);
  return editData  && applicationId ? (
    <Page.Container>
      <ApplicationDetailsPage id={applicationId}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
          <SetBacksInspectionForm
            id="editSetBacksInspectionForm"
            title="Setbacks Inspection"
            action="post"
            applicationInspectionId={editData?.applicationInspectionId}
            applicationId= {applicationId}
            returnPath={`/inspectionDetails/${inspectionId}`}
            values={editData}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
  <Page.Body>
      <Layout.Container>
          <div className="row row-dec row-cards">
              <div className="col-lg-12">
               
              </div>
          </div>
      </Layout.Container>
  </Page.Body>
</Page.Container>;
};

export default EditSetBacksPage;